import { Directive, ElementRef, inject, Input, OnInit } from '@angular/core'
import { fromEvent, takeUntil } from 'rxjs'

import { AnalyticsService } from 'app/core/analytics/analytics.service'
import { AnalyticsEvent } from 'app/core/analytics/analytics-event.enum'
import { onDestroy } from 'app/utils/rxjs/on-destroy.observable'

@Directive({ selector: '[paiTrackEvent]', standalone: true })
export class TrackEventDirective implements OnInit {
  @Input()
  paiTrackEvent: { event: AnalyticsEvent; value?: { [key: string]: string | number | boolean } }

  @Input()
  paiTrackEventOn = 'click'

  readonly elRef = inject(ElementRef)
  private readonly onDestroy$ = onDestroy()
  private readonly analytics = inject(AnalyticsService)

  ngOnInit() {
    fromEvent(this.elRef.nativeElement, this.paiTrackEventOn)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        const { event, value } = this.paiTrackEvent
        this.analytics.trackEvent(event, value)
      })
  }
}
